<template>
  <div class="productContent clearfix moshaBox">
    <div class="jiazaiBox" v-if="data.length===0">
      <div v-if="!is_loading" class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div v-if="is_loading" class="kongBox">
        <i class="iconfont icon-gouwuchekong mb-3"></i>
        <span>购物车是空的</span>
      </div>
    </div>
    <div v-if="data.length!==0 && is_loading" class="searchBox titleBox mb-3">
      <div class="box" v-for="(app,index) in data" :key="index">
        <div class="aa">
          <h5>{{app.name}}</h5>
          <span @click="removeGoods(app.id)" class="cursor" style="color:#FF5630;" v-if="isSource===2">剔除</span> #
          <span class="d-none d-md-inline-block">单价：￥{{app.priceB}}</span>
          <span class="d-block mt-3 d-block d-md-none">单价：￥{{app.priceB}}</span>
        </div>
        <div class="numberBox bb">
          <i @click="numFun('-',app.id)" class="iconfont icon-jian1"></i>
          <input type="text" :value="app.num" @input="inputNumFun(app.id,$event)">
          <i @click="numFun('+',app.id)" class="iconfont icon-plus"></i>
        </div>
      </div>
    </div>
    <div class="btnBox clearfix" v-if="data.length!==0 && is_loading">
      <div class="aa">
        <img src="/static/images/aliPay.svg">
        <img class="m-0" src="/static/images/wechatPay.svg">
      </div>
      <div class="bb">
        <div class="mb-2"><small>总额：</small>￥{{totalPrice}}</div>
        <button v-if="this.parmsData.arr.length>0" @click="purchaseFun" type="button" class="btn btn-primary btn-lg">立即支付</button>
        <button v-else type="button" class="btn btn-outline-secondary btn-round">请选择商品...</button>
      </div>
    </div>
    <ui-pay :parms="parmsData" v-if="purchaseBox" :closePurchaseBox="closePurchaseBox"></ui-pay>
  </div>
</template>

<script>
import resultcommons from '../../util/resultcommons';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';
import uiPay from '@/components/common/pay';
import commons from '../../util/commons';

export default {
  name: 'productContent',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      purchaseBox: false,
      pay:1,
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      info:null,
      data:[],
      is_loading:true,
      isSource:1//1单个商品2购物车
    }
  },
  computed:{
    totalPrice(){
      let money = 0;
      this.data.forEach(app=>{
        money = commons.accAddNumber(money,commons.accMulNumber(app.priceB , app.num));
      })
      return money;
    },
    // 传递给支付模态框的数据
    parmsData() {
      let arr = [];
      this.data.forEach(app=>{
        if(app.num > 0){
          arr.push({
            price: app.priceB,
            num: app.num,
            totalPrice: commons.accMulNumber(app.priceB , app.num),
            id: app.id,
            title: app.name
          });
        }
      });
      return {type:'product',arr:arr,totalPrice:this.totalPrice}
    }
  },
  methods:{
    // 剔除购物车
    removeGoods(id) {
      return window.swal({
        title: '移出购物车?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          // 剔除购物车
          this.data = this.data.filter(app=>{
            return app.id !== id;
          });
          // 剔除本地存储
          const ob = this.localCart;
          const obj = ob.filter(app=>{
            return app !== id;
          });
          commons.saveTodos('localCart' + this.localUser.user, obj);
          this.saveLocalcartFun({ bool: true });
        }
      });
    },
    // 显示详情
    closePurchaseBox() {
      this.purchaseBox = false;
    },
    purchaseFun() {
      if(this.parmsData.arr.length > 0){
        this.purchaseBox = true;
      }
    },
    // 加减
    numFun(type,id) {
      const app = this.data.find(app=>{
        return app.id === id;
      });
      if(app.num > 0 && type === '-'){
        if(app.num === 1){
          this.removeGoods(id);
        }else{
          app.num--;
        }
      }
      if(type === '+'){
        app.num++;
      }
    },
    // 输入数字
    inputNumFun(id, event){
      // 获取填的数值
      const val = event.target.value * 1;
      // 获取第几行
      const info = this.data.find((app) => app.id === id);
      console.log(val);
      console.log(info);
      if (!commons.isNumber(val)) {
        event.target.value = 0;
        info.num = 0;
        // this.$message.showMsgBox({
        //   type: 'warning',
        //   content: '须填写数字'
        // });
      }else if(val === 0){
        info.num = 0;
        event.target.value = 0;
      }else{
        info.num = val;
      }
    }
  },
  components: {
    Multiselect,
    'ui-pay':uiPay
  },
  created() {
    this.is_loading = true;
    // eslint-disable-next-line no-unused-vars
    let arr;
    if(Array.isArray(this.parameter)){
      this.isSource = 2;// 购物车
      arr = this.parameter;
    }else{
      this.isSource = 1;// 单个商品
      this.id = this.parameter.token;
      arr = [this.id];
    }
    if(arr.length !== 0){
      resultcommons.apiGoodsinfo(this,{tokenArr:arr}).then(app=>{
        if(app.state === 200){
          app.data.forEach(app=>{
            app.num = 1;
          });
          this.data = app.data;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message
          });
        }
        this.is_loading = true;
      });
    }else{
      this.is_loading = true;
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.productContent {
  padding: 30px;
  padding-right: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  color: #000000;
  width: 60vw;
  height: 100%;
  overflow-y: auto;
  background: #F5F5F7;
  div.btnBox{
    display: flex;
    div.aa{
      img{
        height: 36px;
        margin-right: 5px;
        padding: 5px;
        /*background: #FFFFFF;*/
        border-radius: 5px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
    div.bb{
      flex: 1;
      flex-direction: column;
      display: flex;
      align-items: end;
      div{
        font-size: 22px;
        font-weight: bold;
        color: #FF5630;
        small{
          font-size: 1rem;
          color: #000000;
        }
      }
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    min-height: 30vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
    }
    .kongBox{
      display: flex;
      flex-direction: column;
      text-align: center;
      i{
        font-size: 36px;
      }
    }
  }
  div.searchBox{
    border-radius: 5px;
    padding: 20px;
    background: #FFFFFF;
    div.box{
      display: flex;
      border-bottom: 2px dashed #F5F5F7;
      padding-bottom: 10px;
      margin-bottom: 10px;
      &:last-child{
        padding-bottom: 0;
        margin-bottom: 0;
        border: 0;
      }
      div.aa{
        flex: 1;
      }
      div.numberBox{
        text-align: right;
        display: flex;
        justify-content: center;
        align-items: center;
        input{
          width: 50px;
          text-align: center;
          border: 0;
          background: #F5F5F7;
          border-radius: 2px;
          margin: 0 5px;
          line-height: 1.8em;
        }
        i{
          cursor: pointer;
          &:active{
            color: #666666;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .productContent{
    width: 70vw;
  }
}

@media (max-width: 992px) {
  .productContent{
    width: 90vw;
  }
}

@media (max-width: 776px) {
  .productContent{
    width: 90vw;
    padding: 10px;
    div.searchBox{
      padding: 20px;
    }
    div.btnBox{
      flex-direction: column;
      div.aa{
        text-align: right;
      }
      div.bb{
        align-items: start;
        justify-content: center;
        align-items: end;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/product/Content.vue